import { Button } from "@/components/ui/button";
import { Utensils, Bed, Bike } from "lucide-react";

type Category = "all" | "food" | "lodging" | "adventure";

interface CategoryButtonsProps {
  activeCategory: Category;
  onCategoryChange: (category: Category) => void;
}

export const CategoryButtons = ({
  activeCategory,
  onCategoryChange,
}: CategoryButtonsProps) => {
  return (
    <div className="flex justify-center gap-4 mb-8">
      <Button
        variant={activeCategory === "all" ? "secondary" : "outline"}
        onClick={() => onCategoryChange("all")}
      >
        Tout voir
      </Button>
      <Button
        variant={activeCategory === "food" ? "secondary" : "outline"}
        onClick={() => onCategoryChange("food")}
      >
        <Utensils className="mr-2" /> Manger local
      </Button>
      <Button
        variant={activeCategory === "lodging" ? "secondary" : "outline"}
        onClick={() => onCategoryChange("lodging")}
      >
        <Bed className="mr-2" /> Dormir insolite
      </Button>
      <Button
        variant={activeCategory === "adventure" ? "secondary" : "outline"}
        onClick={() => onCategoryChange("adventure")}
      >
        <Bike className="mr-2" /> Aventures
      </Button>
    </div>
  );
};